import styled from 'styled-components';

export const InvisibleAnchor = styled.a.attrs({ tabIndex: -1 })`
  &,
  &:visited,
  &:active,
  &:hover,
  &:focus {
    text-decoration: none;
    border: none;
    outline: none;
    color: transparent;
  }
`;
